@if (objectSubtype$ | async) {
  <!--
  object subtypes share the same page component
  unfortunately, glxy-table doesnt deal well with columns changing during execution
  this code exists to force a reload when changing between subtype tabs
  -->
  @if (subtypeChange) {
    <ng-container *ngTemplateOutlet="mobileDesktopSwitcher"></ng-container>
  }
} @else {
  <ng-container *ngTemplateOutlet="mobileDesktopSwitcher"></ng-container>
}

<ng-template #mobileDesktopSwitcher>
  <!--
  table is not playing well with changing columns in execution
  reload when changing between mobile and desktop
  -->
  @if (mobileView$ | async; as mobileView) {
    <div class="mobile-list-page">
      <ng-container *ngTemplateOutlet="listObjects; context: { $implicit: mobileView }"></ng-container>
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="listObjects"></ng-container>
  }
</ng-template>

<ng-template #listObjects let-mobileView>
  <glxy-page [pagePadding]="false">
    <glxy-page-toolbar>
      <glxy-page-title>
        {{ 'TITLE' | translateForCrmObject: typeForTitle | async }}
      </glxy-page-title>

      <glxy-page-actions>
        <ng-content select="crm-page-actions, [crmPageActions]"></ng-content>
        @if (importCSVRouteWithPrefix$ | async; as route) {
          <a
            (click)="navigateToCsvImportRoute(route)"
            [attr.data-action]="'clicked-import-csv-crm-' + objectType.toLowerCase()"
            mat-stroked-button
            data-testid="import-csv-button"
            >
            {{ 'ACTIONS.IMPORT' | translate }}
          </a>
        }
        @if (createObjectRoute$ | async; as create) {
          @if (mobileView) {
            <a
              [routerLink]="create"
              [attr.data-action]="'clicked-add-crm-' + objectType.toLowerCase()"
              data-testid="add-crm-object-button"
              mat-flat-button
              color="primary"
              >
              <mat-icon class="icon-button">add</mat-icon>
            </a>
          } @else {
            <a
              [routerLink]="create"
              [attr.data-action]="'clicked-add-crm-' + objectType.toLowerCase()"
              [disabled]="!canCreateObject()"
              mat-flat-button
              color="primary"
              data-testid="add-crm-object-button"
              >
              {{ 'ADD_OBJECT_BUTTON' | translateForCrmObject: typeForTitle | async }}
            </a>
          }
        }
        <ng-content select="[crmTableContent='page-actions']"></ng-content>
      </glxy-page-actions>
    </glxy-page-toolbar>
    <crm-list-objects-table
      [objectType]="objectType"
      [activityType]="activityType"
      [crmObjectSubtype]="objectSubtype$ | async"
      [rowStyle]="customRowStyle"
      [readOnlyMode]="readOnlyMode"
      (editClick)="editClick.emit($event)"
      (selected)="selectionChange.emit($event)"
      [presetFilters]="presetFilters"
      [showPresetFiltersOverride]="showPresetFiltersOverride()"
      [showViewTabsOverride]="showViewTabsOverride()"
      [hideCustomViews]="hideCustomViews()"
      [multiActions]="multiActions"
      [singleActions]="singleActions"
      [refreshRow$]="refreshRow$"
      (pipelineSelected)="setPipelineSelected($event)"
      (currentView)="storeCurrentView($event)"
    ></crm-list-objects-table>
  </glxy-page>
</ng-template>
